import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'

import { StdMastInfo, AcCodeInfo , StdInstInfo} from './Types'
import { SystemHeader, ClientPicker, FBSClientPicker } from './CommonUI';


import i18next from 'i18next';


interface PageInfo {
    n: number
}

var GsbFlag: any;

var UserID: string;
var PgmCode = "M0040" ;
var isReqAuth2:boolean = false ;
var SysCode2: string;


interface StdMastViewProps {
    gsb: AxiosInstance,
    StdMast: StdMastInfo,
    StdMast0: StdMastInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
}


function StdMastView({ gsb, StdMast = {} as StdMastInfo, StdMast0 = {} as StdMastInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2 }: StdMastViewProps) {

    const { t, i18n } = useTranslation();

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")
    
    const [AcCodeValue, setAcCodeValue] = useState(StdMast.d_acCode)
    const [AcName1Value, setAcName1Value] = useState("")
    const [AcName2Value, setAcName2Value] = useState("")
    const [StdInstCodeValue, setStdInstCodeValue] = useState(StdMast.d_Std_Instruction_code)
    const [InstructionDesc1Value, setInstructionDesc1Value] = useState("")

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    console.log("StdMastView UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, StdMast])

    useEffect(() => {
        (async () => {
            try {
                // get AC Info
                if ( SysCode2 == "Fbsx" ) {
                    const res = await gsb.post('/fbs/Master', {sb_data: "", cPgmId: "CLMast", cAction: "GetCLInfo", cAcct: StdMast.d_acCode})
                    if ( StdMast.d_acCode.trim().length > 0 && res.data.count > 0 )
                    {
                        setAcName1Value(res.data.data[0].d_Name)
                        setAcName2Value(res.data.data[0].d_Name2)
                    } else { 
                        setAcName1Value("")
                        setAcName2Value("")
                    }
                } else {
                    //console.log("StkDepWithTranEntryEdit StkDepWith.d_acCode: ", StkDepWith.d_acCode, AcCodeValue) 
                    const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Clmast", cAction: "GetACInfo", cAcCode: StdMast.d_acCode})
                    //console.log("StkDepWithTranEntryEdit GetACInfo data : ", res.data.data) 
                    //console.log("StkDepWithTranEntryEdit GetACInfo  count: ", res.data.count) 
                    
                    if ( StdMast.d_acCode.trim().length > 0 && res.data.count > 0 )
                    {
                        //setPrevDayValue(res.data.data[0].acbal_PrevDay) 
                        //setLatestQtyValue(res.data.data[0].acbal_LatestBal) 
                        setAcName1Value(res.data.data[0].d_acName1)
                        setAcName2Value(res.data.data[0].d_acName2)
                    } else { 
                        setAcName1Value("")
                        setAcName2Value("")
                    }
                }
            } catch (error) {
                //showErrorBox(error)
            }
        })()

    }, [gsb, StdMast.d_acCode, AcCodeValue])

    useEffect(() => {
        (async () => {
            try {
                // get Instruction Code Info
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "StdInstSetup", cAction: "GetStdInst", cStdInstCode: StdMast.d_Std_Instruction_code, cSysCode: SysCode2})
                
                if ( StdMast.d_Std_Instruction_code.trim().length > 0 && res.data.count > 0 )
                {
                    setInstructionDesc1Value(res.data.data[0].InstructionDesc1)
                } else { 
                    setInstructionDesc1Value("")
                }
            
            } catch (error) {
                //showErrorBox(error)
            }
        })()

    }, [gsb, StdMast.d_Std_Instruction_code])

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


    if (! ("d_Std_Instruction_code" in StdMast)) return null



    return (
        <div>
            { ViewMode === "V" && <div className="Row No-Print">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }
            </div> }
            { ViewMode === "L" && <div>
                {t("Account No.")} : {StdMast.d_acCode}
                {t("Instruction Code")} : {StdMast.d_Std_Instruction_code}
                { (logKey2.indexOf("*A1") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Amend</div> }
                { (logKey2.indexOf("*C") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Create</div> }
                { (logKey2.indexOf("*D") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Delete</div> }
                { ! (StdMast0.d_AuthId.toString() == "") && <div id="DispText2">Auth : {utils.dispDate(StdMast0.d_AuthDate, "3")} {StdMast0.d_AuthTime} User {StdMast0.d_AuthId} </div> }
                <div className="Spacing-V-16" />
            </div> }

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label={t("Account No.")} labelFor="inputacCode">
                    <InputGroup readOnly value={StdMast.d_acCode} />
                </FormGroup>
                <FormGroup className="Col-3-3" label="Client Name">
                    <div>
                    <div id="DispText">{AcName1Value}</div>
                    <div id="DispText">{AcName2Value}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label={t("Instruction Code")} labelFor="inputStdMastCode" labelInfo="*">
                    <InputGroup readOnly value={StdMast.d_Std_Instruction_code} />
                </FormGroup>
                <FormGroup className="Col-3-3" label={t("Instruction Description")} labelFor="inputInstructionDesc1">
                    <div>
                    <div id="DispText">{InstructionDesc1Value}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label={t("Entry Date")} labelFor="inputd_Entry_Date">
                    <InputGroup readOnly value={utils.dispDate(StdMast.d_Entry_Date, GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (StdMast0.d_Entry_Date.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(StdMast0.d_Entry_Date, GsbFlag.dateFormat)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label={t("Renewal Date")} labelFor="inputd_Renewal_Date">
                    <InputGroup readOnly value={utils.dispDate(StdMast.d_Renewal_Date, GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (StdMast0.d_Renewal_Date.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(StdMast0.d_Renewal_Date, GsbFlag.dateFormat)} </div> }
                </FormGroup>
                <FormGroup className="Col-2-1" label={t("Last Renewal Date")} labelFor="inputd_LastRenewal_Date">
                    <InputGroup readOnly value={utils.dispDate(StdMast.d_LastRenewal_Date, GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (StdMast0.d_LastRenewal_Date.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(StdMast0.d_LastRenewal_Date, GsbFlag.dateFormat)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label={t("Renew Cycle (No.of Months, 0=Stop Renewal)")} labelFor="inputd_Renew_Cycle">
                    <InputGroup readOnly value={utils.formatNumber2(StdMast.d_Renew_Cycle)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (StdMast0.d_Renew_Cycle.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(StdMast0.d_Renew_Cycle)} </div> }
                </FormGroup>
            </div>
        </div>
    )
}


interface StdMastEditProps {
    gsb: AxiosInstance,
    StdMast?: StdMastInfo,
    isNew?: boolean,
    onSave?: (StdMast: StdMastInfo) => void,
    onCancel?: () => void;
}

function StdMastEdit({ gsb, StdMast = {} as StdMastInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: StdMastEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<StdMastInfo>()
    const { t, i18n } = useTranslation();
    
    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [StdInstCodeList, setStdInstCodeList] = useState([] as StdInstInfo[]) 
    
    const [AcCodeValue, setAcCodeValue] = useState(StdMast.d_acCode)
    const [setClCodeValue, setSetClCodeValue] = useState(() => setAcCodeValue)
    const [isClPickerOpen, setIsClPickerOpen] = useState(false)
    const [AcCodeList, setAcCodeList] = useState([] as AcCodeInfo[])
    const [AcName1Value, setAcName1Value] = useState("")
    const [AcName2Value, setAcName2Value] = useState("")
    const [StdInstCodeValue, setStdInstCodeValue] = useState(StdMast.d_Std_Instruction_code)
    const [InstructionDesc1Value, setInstructionDesc1Value] = useState("")


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])



    useEffect(() => {
        // Call reset to get the values of record StkInfo 
        if ("d_acCode" in StdMast) {
            reset(StdMast)
        }
    }, [StdMast, reset])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])


    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    console.log("StdMastView UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, StdMast])


    useEffect(() => {
        (async () => {
            try {
                // get AC Info
                if ( SysCode2 == "Fbsx" ) {
                    const res = await gsb.post('/fbs/Master', {sb_data: "", cPgmId: "CLMast", cAction: "GetCLInfo", cAcct: AcCodeValue})
                    if ( AcCodeValue.trim().length > 0 && res.data.count > 0 )
                    {
                        setAcName1Value(res.data.data[0].d_Name)
                        setAcName2Value(res.data.data[0].d_Name2)
                    } else { 
                        setAcName1Value("")
                        setAcName2Value("")
                    }
                } else {
                    //console.log("StkDepWithTranEntryEdit StkDepWith.d_acCode: ", StkDepWith.d_acCode, AcCodeValue) 
                    const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Clmast", cAction: "GetACInfo", cAcCode: AcCodeValue, cSysCode: SysCode2})
                    //console.log("StkDepWithTranEntryEdit GetACInfo data : ", res.data.data) 
                    //console.log("StkDepWithTranEntryEdit GetACInfo  count: ", res.data.count) 
                    
                    if ( AcCodeValue.trim().length > 0 && res.data.count > 0 )
                    {
                        //setPrevDayValue(res.data.data[0].acbal_PrevDay) 
                        //setLatestQtyValue(res.data.data[0].acbal_LatestBal) 
                        setAcName1Value(res.data.data[0].d_acName1)
                        setAcName2Value(res.data.data[0].d_acName2)
                    } else { 
                        setAcName1Value("")
                        setAcName2Value("")
                    }
                }
            } catch (error) {
                //showErrorBox(error)
            }
        })()

    }, [gsb, AcCodeValue])

    useEffect(() => {
        (async () => {
            try {
                // get Instruction Code Info
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "StdInstSetup", cAction: "GetStdInst", cStdInstCode: StdInstCodeValue, cSysCode: SysCode2})
                
                if ( StdInstCodeValue.trim().length > 0 && res.data.count > 0 )
                {
                    setInstructionDesc1Value(res.data.data[0].InstructionDesc1)
                } else { 
                    setInstructionDesc1Value("")
                }
            
            } catch (error) {
                //showErrorBox(error)
            }
        })()

    }, [gsb, StdInstCodeValue])
    
    useEffect(() => {
        (async () => {
            try {
                // get Standing Instruction Code List
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "StdInstSetup", cAction: "GetStdInstList", cSysCode: SysCode2})
                setStdInstCodeList(res.data.data)
            } catch (error) {
                utils.showError(error)
                }
        })()
    }, [gsb])

    if (! isNew && ! ("d_acCode" in StdMast)) return null

    let acNoLength = 8
    if ( GsbFlag.user_key === "DJSEC" ) {
        acNoLength = 10
    }
    if ( GsbFlag.user_key === "GEO" ) {
        acNoLength = 11
    }

    
    const onSubmit = (data: StdMastInfo) => {

        //console.log("StdMastEdit onsubmit data: ", data)

        // put value to json/field before write database dbf
        data.d_acCode = AcCodeValue.toUpperCase();
        data.d_Std_Instruction_code = StdInstCodeValue.toUpperCase();

        data.d_AuthTran = ""
        if (isReqAuth) {
            data.d_AuthTran = "Y"
        }

        (async () => {
            try {
                console.log("call StdMastEdit data", data)
                //console.log("call StdMastEdit isNew", isNew)
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "StdMast", cAction: "StdMastValidate", isNew: isNew, cSysCode: SysCode2})
                //console.log("StdMastEdit res.data.ok", res.data.ok)
                //console.log("StdMastEdit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }

                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()

        //onSave(data)
    }

    const StdInstRenderer: ItemRenderer<StdInstInfo> = (StdInstList, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${StdInstList.d_Std_Instruction_Description}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={StdInstList.d_Std_Instruction_code}
                key={StdInstList.d_Std_Instruction_Description}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const StdInstPredicate: ItemPredicate<StdInstInfo> = (query, StdInstList, _index, exactMatch) => {
        const normalizedText = `${StdInstList.d_Std_Instruction_code} - ${StdInstList.d_Std_Instruction_Description}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const StdInstValueRenderer = (StdInstList: StdInstInfo) => {
        return StdInstList.d_Std_Instruction_code
    }


    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            { ( SysCode2 == "Fbsx" ) &&
                <FBSClientPicker gsb={gsb} isOpen={isClPickerOpen} onClose={()=>setIsClPickerOpen(false)} onSelect={(ac)=>{setClCodeValue(ac.d_Acct); setIsClPickerOpen(false)}}/>
            }
            { ! ( SysCode2 == "Fbsx" ) &&
                <ClientPicker gsb={gsb} isOpen={isClPickerOpen} onClose={()=>setIsClPickerOpen(false)} onSelect={(ac)=>{setClCodeValue(ac.d_acCode); setIsClPickerOpen(false)}}/>
            }
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label={t("Account No.")} labelFor="inputacCode" labelInfo="*">
                    <InputGroup disabled={! isNew} id="inputacCode" autoFocus={isNew} value={AcCodeValue} defaultValue="" placeholder="Account No. ..." onChange={utils.handleStringChange(s => setAcCodeValue(s.toUpperCase())) } inputRef={register({ required: true , maxLength: acNoLength}) } 
                        rightElement={<Button icon="double-chevron-down" minimal onClick={() => {setSetClCodeValue(()=>setAcCodeValue); setIsClPickerOpen(true)}}></Button>}
                    />
                    {errors.d_acCode && errors.d_acCode.type === "required" && <span id="Err_msg">Account No. cannot be Blank</span>}
                    {errors.d_acCode && errors.d_acCode.type === "maxLength" && <span id="Err_msg">Max length is {acNoLength}</span>}
                    {errors.d_acCode && errors.d_acCode.types && <span id="Err_msg">{errors.d_acCode.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-3" label="Client Name" labelFor="inputAcName1">
                    <div>
                    <div id="DispText">{AcName1Value}</div>
                    <div id="DispText">{AcName2Value}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label={t("Instruction Code")} labelFor="inputStdMastCode" labelInfo="*">
                    <Suggest2
                            disabled={! isNew}
                            inputProps={{ placeholder: "Instruction Code ..." }}
                            activeItem={StdInstCodeList.find((StdInst) => StdInst.d_Std_Instruction_code === StdInstCodeValue)}
                            selectedItem={StdInstCodeList.find((StdInst) => StdInst.d_Std_Instruction_code === StdInstCodeValue)}
                            items={StdInstCodeList}
                            itemRenderer={StdInstRenderer}
                            itemPredicate={StdInstPredicate}
                            inputValueRenderer={StdInstValueRenderer}
                            onItemSelect={(itemCode) => { setStdInstCodeValue(itemCode.d_Std_Instruction_code) }}
                        />
                    {errors.d_Std_Instruction_code && errors.d_Std_Instruction_code.types && <span id="Err_msg">{errors.d_Std_Instruction_code.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-3" label={t("Instruction Description")} labelFor="inputInstructionDesc1">
                    <div>
                    <div id="DispText">{InstructionDesc1Value}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label={t("Entry Date")} labelFor="inputd_Entry_Date">
                    <InputGroup id="inputd_Entry_Date" name="d_Entry_Date" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                    {errors.d_Entry_Date && errors.d_Entry_Date.types && <span id="Err_msg">{errors.d_Entry_Date.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label={t("Renewal Date")} labelFor="inputd_Renewal_Date">
                    <InputGroup id="inputd_Renewal_Date" name="d_Renewal_Date" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                    {errors.d_Renewal_Date && errors.d_Renewal_Date.types && <span id="Err_msg">{errors.d_Renewal_Date.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label={t("Last Renewal Date")} labelFor="inputd_LastRenewal_Date">
                    <InputGroup id="inputd_LastRenewal_Date" name="d_LastRenewal_Date" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                    {errors.d_LastRenewal_Date && errors.d_LastRenewal_Date.types && <span id="Err_msg">{errors.d_LastRenewal_Date.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label={t("Renew Cycle (No.of Months, 0=Stop Renewal)")} labelFor="inputd_Renew_Cycle">
                    <InputGroup className="inputNumberNoSpin" id="inputd_Renew_Cycle" name="d_Renew_Cycle" defaultValue="0" type="number" inputRef={register({min: 0})} />
                    {errors.d_Renew_Cycle && errors.d_Renew_Cycle.type === "min" && <span id="Err_msg">Stamp Fee sholud be greater than 0 </span>}
                    {errors.d_Renew_Cycle && errors.d_Renew_Cycle.types && <span id="Err_msg">{errors.d_Renew_Cycle.types.message}</span>}
                </FormGroup>
            </div>
        </form>
    )
}

interface StdMastMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function StdMastMain({ gsb }: StdMastMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let syscode = utils.getUrlParameter('syscode', url); 

    let { StdMastCode: defaultSearchValue = "" }: { StdMastCode: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as StdMastInfo[])

    const [searchKey, setSearchKey] = useState("acCode")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentStdMast, setCurrentStdMast] = useState({} as StdMastInfo)
    const [BlankStdMast, setBlankStdMast] = useState({} as StdMastInfo)
    const [CurrentLog1, setCurrentLog1] = useState({} as StdMastInfo)
    const [CurrentLog0, setCurrentLog0] = useState({} as StdMastInfo)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    
    SysCode2 = syscode.substring(0,4)

    //gsb default value
    BlankStdMast.d_acCode = ""
    BlankStdMast.d_Std_Instruction_code = ""


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("StdMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("StdMastMain disp MULTI_StdMast: ", res.data.Flag.MULTI_StdMast)
                //console.log("StdMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("StdMastMain disp GsbFlag: ", GsbFlag)
                //console.log("StdMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("StdMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                UserID = res.data.Flag.UserID
                //console.log("StdMastMain disp GsbFlag.MULTI_StdMast: ", sbFlag.MULTI_StdMast)
                //console.log("StdMastMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("StdMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("StdMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])


    useEffect(() => {

        if (logviewonly === "Y") {
            setViewMode("L")
        }
        //console.log("ClMastMain ViewMode: ", ViewMode)

        if (SysCode2 == "Fbsx" ) {
            PgmCode = "FM0040"
        } else {
            PgmCode = "M0040"
        }

        ;
        (async () => {
            try {
                if ( logKey.trim().length > 0 && logviewonly === "Y" ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_logKey: logKey,
                        }, 
                        cPgmId: "StdMast", 
                        cAction: "ViewLogRec",
                        cSysCode: SysCode2,
                    })
                    //console.log("ClMastMain Clmast ViewLogRec res.data.data", res.data.data)

                    if (res.data.ok) {
                        setCurrentLog0(res.data.data[0])
                        setCurrentLog1(res.data.data[1])
                    } else {
                        utils.showWarn(res.data.data)
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, logKey])
    
    const PrevRecProcess = async (StdMast: StdMastInfo) => {
        try {
            //console.log("call PrevRecProcess", StdMast)
            const res = await gsb.post('/Master', {sb_data: StdMast,  cPgmId: "StdMast",cAction: "PrevRec", cSysCode: SysCode2})
            //console.log("PrevRecProcess show 1: ", d_StdMastCode.d_StkNo)
            //console.log("PrevRecProcess data : ", data)
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode+data[i].d_Std_Instruction_code === res.data.data.d_acCode+res.data.data.d_Std_Instruction_code) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            //console.log("PrevRecProcess res.data.data : ", res.data.data)
            setCurrentStdMast(res.data.data)
            //console.log("PrevRecProcess show 2: ", stk.d_StkNo)
            setCurrentMode("show")
            //console.log("PrevRecProcess show 3: ", stk.d_StkNo)
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (StdMast: StdMastInfo) => {
        try {
            StdMast.d_AuthTran = ""
            if (isReqAuth2) {
                StdMast.d_AuthTran = "Y"
            }
            //console.log("call DeleteProcess", StdMast)
            const res = await gsb.post('/Master', {sb_data: StdMast, cPgmId: "StdMast", cAction: "DelRec", cSysCode: SysCode2})
            if (isReqAuth2) {
                showSuccess("Account No., Standing Instruction Code " + StdMast.d_acCode +","+ StdMast.d_Std_Instruction_code + " record deleting, waiting for authorization")
            } else {
                showSuccess("Account No., Standing Instruction Code " + StdMast.d_acCode +","+ StdMast.d_Std_Instruction_code + " record deleted")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_acCode+data[i].d_Std_Instruction_code === res.data.data.d_acCode+res.data.data.d_Std_Instruction_code) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setCurrentStdMast(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                setisShowAlert1(true)
                setShowAlert1Msg("Account No., Standing Instruction Code " + StdMast.d_acCode +","+ StdMast.d_Std_Instruction_code + " record deleting, waiting for authorization")
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (StdMast: StdMastInfo) => {
        try {
            //console.log("call NextRecProcess", StdMast)
            const res = await gsb.post('/Master', {sb_data: StdMast, cPgmId: "StdMast", cAction: "NextRec", cSysCode: SysCode2})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode+data[i].d_Std_Instruction_code === res.data.data.d_acCode+res.data.data.d_Std_Instruction_code) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentStdMast(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (StdMast: StdMastInfo) => {
        try {
            //console.log("call newOnSave", StdMast)
            const res = await gsb.post('/Master', {sb_data: StdMast, cPgmId: "StdMast", cAction: "AddRec", cSysCode: SysCode2})
            if (isReqAuth2) {
                showSuccess("Account No., Standing Instruction Code " + StdMast.d_acCode +","+ StdMast.d_Std_Instruction_code + " record adding, waiting for authorization")
            } else {
                showSuccess("Account No., Standing Instruction Code " + StdMast.d_acCode +","+ StdMast.d_Std_Instruction_code + " record added")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_acCode+data[i].d_Std_Instruction_code === res.data.data.d_acCode+res.data.data.d_Std_Instruction_code) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setCurrentStdMast(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                setisShowAlert1(true)
                setShowAlert1Msg("Account No., Standing Instruction Code " + StdMast.d_acCode +","+ StdMast.d_Std_Instruction_code + " record adding, waiting for authorization")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (StdMast: StdMastInfo) => {
        try {
            console.log("call editOnSave", StdMast)
            const res = await gsb.post('/Master', {sb_data: StdMast, cPgmId: "StdMast", cAction: "UpdateRec", cSysCode: SysCode2})
            if (isReqAuth2) {
                showSuccess("Account No., Standing Instruction Code " + StdMast.d_acCode +","+ StdMast.d_Std_Instruction_code + " record saving, waiting for authorization")
            } else {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_acCode+data[i].d_Std_Instruction_code === res.data.data.d_acCode+res.data.data.d_Std_Instruction_code) {
                        setCurrentStdMast(data[i])
                        break
                    }
                }
                showSuccess("Account No., Standing Instruction Code " + StdMast.d_acCode +","+ StdMast.d_Std_Instruction_code + " record saved")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_acCode+data[i].d_Std_Instruction_code === res.data.data.d_acCode+res.data.data.d_Std_Instruction_code) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            //console.log("editOnSave stk", StdMast)
            //console.log("editOnSave res.data.data", res.data.data)
            setCurrentStdMast(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        // get SmMast list if StkNo have value
        try {
            //console.log("StdMastMain onsubmit called", data)
            const res = await gsb.post('/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                        }, 
                    },
                    cPgmId: "StdMast",
                    cAction: "ListRec",
                    cSysCode: SysCode2,
                });

            if ( m_limit > 1 ) {
                setData(res.data.data)
            }
            if (res.data.data.length > 0) {
                setCurrentStdMast(res.data.data[0])
                console.log("StdMastMain onsubmit CurrentStdMast", currentStdMast)
            }

            if ( m_limit > 1 ) {
                if ( res.data.count > 0 ) {
                const aPageNumber1 = []
                if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                    }
                        setaPageNumber(aPageNumber1)
                    }
                }
            }
            setShowWait(false)
        } catch (error) {
            utils.showError(error)
        }
    }

    // get one SmMast record if StkNo have value
    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            // console.log("calling API for URL param");

            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 

            (async () => {
                //console.log("StdMastMain useEffect length > 0  called", data)
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "StdMast",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "StdMast",
                        cAction: "ListRec",
                        cSysCode: SysCode2,
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentStdMast(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                            }, 
                        },
                        cPgmId: "StdMast",
                        cAction: "ListRec",
                        cSysCode: SysCode2,
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setCurrentStdMast(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }


    // currentMode = show
    let detail = <StdMastView gsb={gsb} StdMast={currentStdMast} StdMast0={currentStdMast} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentStdMast)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentStdMast)} onNextRec={() => NextRecProcess(currentStdMast)} ViewMode={ViewMode} logKey2={logKey2.trim()} ></StdMastView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <StdMastEdit gsb={gsb} StdMast={BlankStdMast} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } ></StdMastEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <StdMastEdit gsb={gsb} StdMast={currentStdMast} onSave={editOnSave} onCancel={() => setCurrentMode("show")} ></StdMastEdit>
            break
    }

    let logKeyViewRec = <StdMastView gsb={gsb} StdMast={CurrentLog1} StdMast0={CurrentLog0} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentStdMast)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentStdMast)} onNextRec={() => NextRecProcess(currentStdMast)} ViewMode={ViewMode} logKey2={logKey2.trim()} ></StdMastView>

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>

    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1"  disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-ACCode">Account No.</th>
                <th className="TCol-InstructionCode">Instruction Code</th>
                <th className="TCol-TranDate">Renewal Date</th>
                <th className="TCol-TranDate">Last Renewal Date</th>
                <th className="TCol-Cycle">Renew Cycle</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((StdMast, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td className="TCol-ACCode" onClick={() => { setCurrentStdMast(StdMast) ; MoblieDev && setSelectedTabId("detail") }}>{StdMast.d_acCode}</td>
                        <td className="TCol-InstructionCode" onClick={() => { setCurrentStdMast(StdMast) ; MoblieDev && setSelectedTabId("detail") }}>{StdMast.d_Std_Instruction_code}</td>
                        <td className="TCol-TranDate" onClick={() => { setCurrentStdMast(StdMast) ; MoblieDev && setSelectedTabId("detail") }}>{utils.dispDate(StdMast.d_Renewal_Date, GsbFlag.dateFormat)}</td>
                        <td className="TCol-TranDate" onClick={() => { setCurrentStdMast(StdMast) ; MoblieDev && setSelectedTabId("detail") }}>{utils.dispDate(StdMast.d_LastRenewal_Date, GsbFlag.dateFormat)}</td>
                        <td className="TCol-Cycle" onClick={() => { setCurrentStdMast(StdMast) }}>{StdMast.d_Renew_Cycle}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>

    return (
        <>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    {/* define search key */}
                    <H3><div style={{justifyContent: 'flex-end'}}>Standing Instruction Entry</div></H3>
                    <div className="Row">
                        <FormGroup className="Col-1-5" label="Search for " labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                <option value="acCode">Account No.</option>
                                <option value="StdInstCode">Instruction Code</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "acCode"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "acCode"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                    </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            {/* <FormGroup className="Col-5-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup> */}
                        </div>
                    </Collapse>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Client Master Log View</H3>
                    <div className="Spacing-V-16" />
                    {logKeyViewRec}
                </Card> }

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default StdMastMain